function isServerSide() {
  return typeof window === 'undefined'
}

function isClientSide() {
  return typeof window !== 'undefined'
}

export { isServerSide, isClientSide }
